module.exports = __webpack_public_path__ + "img/valores-respeito.bcd411c7.svg";